"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveEndpointId = exports.getEndpointId = exports.getCacheKey = exports.createEndpointId = exports.cacheEndpointId = void 0;
var cacheEndpointId_1 = require("./cacheEndpointId");
Object.defineProperty(exports, "cacheEndpointId", { enumerable: true, get: function () { return cacheEndpointId_1.cacheEndpointId; } });
var createEndpointId_1 = require("./createEndpointId");
Object.defineProperty(exports, "createEndpointId", { enumerable: true, get: function () { return createEndpointId_1.createEndpointId; } });
var getCacheKey_1 = require("./getCacheKey");
Object.defineProperty(exports, "getCacheKey", { enumerable: true, get: function () { return getCacheKey_1.getCacheKey; } });
var getEndpointId_1 = require("./getEndpointId");
Object.defineProperty(exports, "getEndpointId", { enumerable: true, get: function () { return getEndpointId_1.getEndpointId; } });
var resolveEndpointId_1 = require("./resolveEndpointId");
Object.defineProperty(exports, "resolveEndpointId", { enumerable: true, get: function () { return resolveEndpointId_1.resolveEndpointId; } });
